import React from 'react'
import { Wrapper } from "./PriorityCardEntitySm.styled";
import UserIcon from "../../../../assets/svg/boy-avatar.svg";


const CustomStyles = {
    bgColor: { backgroundColor: '#131f28' },
}

const PriorityCardEntitySm = ({ isSmall, user, selectAvaliableUser, selectedUser, isDragging }) => {
    return (
        <Wrapper isSmall={isSmall} isDragging={isDragging}>
            <div className="avaiable-user-proto" onClick={() => selectAvaliableUser(user._id)} style={selectedUser === user._id ? CustomStyles.bgColor : {}}>
                <div className="img-box">
                    <img src={user.profilePicture ? user.profilePicture : UserIcon} alt="User Image" />
                </div>
                <div className="nameuser">{user.username}</div>
            </div>
        </Wrapper>
    )
}

export default PriorityCardEntitySm
